import { render, staticRenderFns } from "./ProductGroup.vue?vue&type=template&id=1b42538c&scoped=true&"
import script from "./ProductGroup.vue?vue&type=script&lang=js&"
export * from "./ProductGroup.vue?vue&type=script&lang=js&"
import style0 from "./ProductGroup.vue?vue&type=style&index=0&id=1b42538c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b42538c",
  null
  
)

export default component.exports